import React, { useState } from "react";
import { toast } from "sonner";
import { Save, CheckCircle2, Loader2, PenLine } from "lucide-react";
import { api, apiError } from "../../lib/api";

export const ExerciseBox = ({ exercise, onSaved, basePath = "/academia" }) => {
  const [text, setText] = useState(exercise.saved_answer || "");
  const [saving, setSaving] = useState(false);
  const saved = !!exercise.saved_answer;

  const save = async () => {
    if (!text.trim()) return toast.error("Escribe tu respuesta antes de guardar");
    setSaving(true);
    try {
      const { data } = await api.post(`${basePath}/exercise`, { exercise_id: exercise.exercise_id, answer: text });
      toast.success("Respuesta guardada ✓");
      onSaved(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid={`exercise-${exercise.exercise_id}`} className="rounded-xl border border-yellow-400/25 bg-black/25 p-4 mt-3">
      <div className="flex items-center gap-2">
        <PenLine size={15} className="text-yellow-400 shrink-0" />
        <h4 className="font-semibold text-sm text-yellow-300">{exercise.title}</h4>
        {saved && <CheckCircle2 size={16} className="text-emerald-400 shrink-0" data-testid={`exercise-done-${exercise.exercise_id}`} />}
      </div>
      <p className="text-xs text-zinc-300 mt-1.5">{exercise.instructions}</p>
      <textarea
        data-testid={`exercise-input-${exercise.exercise_id}`}
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={4}
        placeholder="Escribe aquí tu respuesta…"
        className="mt-3 w-full rounded-lg bg-black/40 border border-white/15 px-3 py-2.5 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-yellow-400"
      />
      <button
        data-testid={`exercise-save-${exercise.exercise_id}`}
        onClick={save}
        disabled={saving}
        className="mt-2 inline-flex items-center gap-1.5 rounded-lg px-4 py-2 text-xs font-bold bg-yellow-400 text-emerald-950 hover:bg-yellow-300 disabled:opacity-50"
      >
        {saving ? <Loader2 className="animate-spin" size={13} /> : <Save size={13} />} {saved ? "Actualizar respuesta" : "Guardar respuesta"}
      </button>
    </div>
  );
};
